import { makeElementClassNameFactory, makeRootClassName } from '@shared/utils';

export const ROOT = makeRootClassName('DocViewer');
export const el = makeElementClassNameFactory(ROOT);
